import { ProductoAmazon } from "@/shared/dtos/productosAmazon/ProductoAmazon";
import { clients } from "@/shared/dtos/clients";
import { CartItem } from "@/shared/dtos/CartItem";
import clientModule from "@/store/modules/client-module";
import { ClientsLocalService } from "../services/clients_local_service";
/**
 * Modelo de carrito (actual o histórico)
 */
export class Cart {
    public id: string;
    public client: clients | null;
    public items: CartItem[];
    public created_at: Date;
    public updated_at: Date;
    public note?: string;

    constructor(data?: Partial<Cart>) {

        this.id = (data && data.id) ? data.id : Cart.generateId();
        //this.client = (data && data.client) ? new clients(data.client as any) : null;

        this.client = ClientsLocalService.load();
        var itemsSrc: any[] = [];
        if (data && (data as any).items) { itemsSrc = (data as any).items as any[]; }
        this.items = itemsSrc.map(function (i: any) { return new CartItem(i); });

        this.created_at = (data && (data as any).created_at) ? new Date((data as any).created_at as any) : new Date();
        this.updated_at = (data && (data as any).updated_at) ? new Date((data as any).updated_at as any) : new Date();
        this.note = (data && (data as any).note) ? (data as any).note as any : undefined;
    }


    static generateId(prefix: string = "cart"): string {
        // id aleatorio hex de 16 bytes (32 caracteres)
        var bytes = new Uint8Array(8);
        var usedCrypto = false;
        try {
            if (typeof window !== "undefined" && window && (window as any).crypto && typeof (window as any).crypto.getRandomValues === "function") {
                (window as any).crypto.getRandomValues(bytes);
                usedCrypto = true;
            }
        } catch (_e) { /* noop */ }

        if (!usedCrypto) {
            for (var i = 0; i < bytes.length; i++) {
                bytes[i] = Math.floor(Math.random() * 256);
            }
        }

        var hex = Array.from(bytes).map(function (b) {
            return ("0" + b.toString(16)).slice(-2);
        }).join("");

        return prefix + "_" + hex;
    }

    addItem(product: ProductoAmazon, qty = 1) {
        const existing = this.items.find(i => i.productId === (product as any).id);
        if (existing) {
            existing.qty = Math.min(999, existing.qty + qty);
        } else {
            this.items.push(new CartItem({ product: product as any, qty }));
        }
        this.touch();
    }

    removeItemByProductId(productId: number) {
        this.items = this.items.filter(i => i.productId !== productId);
        this.touch();
    }

    updateQty(productId: number, qty: number) {
        const it = this.items.find(i => i.productId === productId);
        if (it) {
            it.qty = Math.max(1, Math.min(999, Math.floor(qty)));
            this.touch();
        }
    }

    clear() {
        this.items = [];
        this.touch();
    }

    get itemCount(): number {
        return this.items.reduce((s, i) => s + i.qty, 0);
    }

    get subtotal(): number {
        return this.items.reduce((s, i) => s + i.lineTotal, 0);
    }

    toPlain() {
        if (this.client === null) {
            this.client = ClientsLocalService.load();
        }
        return {
            id: this.id,
            client: this.client ? { ...(this.client as any) } : null,
            items: this.items.map(i => i.toPlain()),
            created_at: this.created_at.toISOString(),
            updated_at: this.updated_at.toISOString(),
            note: this.note,
        };
    }

    private touch() {
        this.updated_at = new Date();
    }
}
